import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getEmployees = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}getallemployees`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getEmployees